module.exports = __webpack_public_path__ + "img/big3-10.81622799.jpg";